// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestionsCarousel-cls1_o0x","cls2":"SuggestionsCarousel-cls2_7GM SuggestionsCarousel-cls1_o0x"};